<svg
  xmlns="http://www.w3.org/2000/svg"
  width="40"
  height="40"
  viewBox="0 0 40 40"
  fill="none"
>
  <circle
    cx="20"
    cy="20"
    r="20"
    [style.fill]="bgColor"
  />
  <circle
    cx="20"
    cy="20"
    r="12"
    [style.fill]="fillColor"
    [style.stroke]="color"
    stroke-width="0.979807"
  />
  <circle
    cx="20.0003"
    cy="20"
    r="8.26712"
    fill="white"
    [style.stroke]="color"
    stroke-width="0.979807"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M24.8441 17.5043V19.3286C24.8441 20.2815 24.135 21.0661 23.2347 21.1461L23.083 21.1528H22.2025V21.6089C22.2025 22.5618 21.4934 23.3465 20.5931 23.4264L20.4414 23.4331H16.9193C15.9993 23.4331 15.2419 22.6986 15.1647 21.766L15.1582 21.6089V20.2407H16.0387V21.6089C16.0387 22.0731 16.3753 22.4575 16.809 22.5139L16.9193 22.521H20.4414C20.8896 22.521 21.2606 22.1723 21.3151 21.7231L21.322 21.6089V21.1528H20.4414V20.2407H23.083C23.5312 20.2407 23.9022 19.892 23.9567 19.4428L23.9635 19.3286V17.5043H24.8441Z"
    [style.fill]="color"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M24.8447 21.6089V23.4331H23.0837V22.521H23.9642V21.6089H24.8447Z"
    [style.fill]="color"
  />
</svg>
